export default __webpack_public_path__ + "static/media/C240253.303d5021.jpg";